import { z } from 'zod'

/** Upper bound for the entity name a tool sends along to title its asset. */
export const ASSET_LABEL_MAX_LENGTH = 120

export const generatedAssetToolSchema = z.enum([
  'format',
  'crop',
  'filter',
  'edit',
  'refine',
  'event',
  'qr',
  'flyer',
  'menu',
  'social',
])

export type GeneratedAssetTool = z.infer<typeof generatedAssetToolSchema>

export const generatedAssetSchema = z.object({
  id: z.string().uuid(),
  tool: generatedAssetToolSchema,
  title: z.string(),
  url: z.string(),
  mimeType: z.string(),
  bytes: z.number().int(),
  width: z.number().int().nullable(),
  height: z.number().int().nullable(),
  createdAt: z.string(),
})

export type GeneratedAsset = z.infer<typeof generatedAssetSchema>

export const listGeneratedAssetsQuerySchema = z.object({
  tool: generatedAssetToolSchema.optional(),
})

export type ListGeneratedAssetsQuery = z.infer<typeof listGeneratedAssetsQuerySchema>

export const listGeneratedAssetsResponseSchema = z.object({
  assets: z.array(generatedAssetSchema),
})

export type ListGeneratedAssetsResponse = z.infer<typeof listGeneratedAssetsResponseSchema>
